import { useApiClient } from "@/composables/useApiClient";

export function useStartPageQueries() {
  const queryClient = useQueryClient();
  const { items: itemsService, apps: appsService } = useApiClient();

  const useItemsQuery = (opts = {}) => {
    return useQuery(
      {
        queryKey: ["items"],
        queryFn: () =>
          itemsService.listRecentlyCreatedItems({
            limit: 4,
          }),
        placeholderData: keepPreviousData,
        ...opts,
      },
      queryClient
    );
  };

  const useAppsQuery = () => {
    return useQuery(
      {
        queryKey: ["apps"],
        queryFn: () => appsService.listApps(),
        placeholderData: keepPreviousData,
      },
      queryClient
    );
  };

  return {
    useItemsQuery,
    useAppsQuery,
  };
}
